const toFixed = (value, length = 1) => {
  const f = Math.pow(10, length);
  return Math.round(value * f) / f;
};

module.exports = {
  toFixed,
};
